// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__srSmZ","col":"styles_col__3i61s"};